import axios from 'axios'
import constConf from '../../../constconf'
export default {
    query: (context, payload) => {
        axios.defaults.withCredentials = true
        let method = payload.hasOwnProperty('method') ? payload.method : 'get'
        return axios({ method: method, url: payload.url })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                console.log(error)
                return { type: 'Query Error', response: { text: 'Запрос прошел с ошибкой. Напишите об этом администратору сайта.' } }
            })
    },
    queryWithData: (context, payload) => {
        axios.defaults.withCredentials = true
        return axios({
            method: payload.method,
            url: payload.url,
            data: payload.data
        })
            .then((response) => {
                return response.data
            })
            .catch((error) => {
                console.log(error)
                return { type: 'Query Error', response: { text: 'Запрос прошел с ошибкой. Напишите об этом администратору сайта.' } }
            })
    }
}
